import Box from "@mui/material/Box"

import recruitingHeroImage from "../../../static/images/admin-login-handshake.png"

export default function AuthRecruitingInfographic() {
  return (
    <Box
      sx={{
        display: { xs: "none", md: "block" },
        flex: 1,
        position: "relative",
        overflow: "hidden",
        bgcolor: "#F5F6FA",
      }}
    >
      <Box
        component="img"
        src={recruitingHeroImage}
        alt="Two real estate professionals shaking hands"
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center center",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(135deg, rgba(147, 32, 213, 0.72) 0%, rgba(138, 53, 208, 0.55) 45%, rgba(254, 53, 207, 0.35) 100%)",
        }}
      />
    </Box>
  )
}
